<template>
  <div>
    <Row>
      <Spin v-if="hyperVisorsGetting" fix></Spin>
      <Alert v-else-if="hyperVisorsError" type="error" show-icon>
        获取主机资源情况失败
        <a style="float: right" v-on:click="getHyperVisors">刷新</a>
      </Alert>
      <div v-else>
        <Row style="margin-bottom: 10px">
          <Card shadow>
            <div slot="title">
              <span>所有主机资源情况</span>
            </div>
            <Row>
              <Col :lg="8" style="text-align: center">
                <i-circle
                  :size="200"
                  :trail-width="4"
                  :stroke-width="5"
                  :percent="(totalHyperVisors.vcpus.used / totalHyperVisors.vcpus.total) * 100 > 100 ? 100 : (totalHyperVisors.vcpus.used / totalHyperVisors.vcpus.total) * 100"
                  stroke-linecap="square"
                  :stroke-color="(totalHyperVisors.vcpus.used / totalHyperVisors.vcpus.total) * 100 > 80 ? dangerColor : cgColor">
                  <div class="demo-Circle-custom">
                    <h3>已用：{{ totalHyperVisors.vcpus.used }}</h3>
                    <p>总共：{{ totalHyperVisors.vcpus.total }}</p>
                    <span>
                  <i>Vcpus</i>
                </span>
                  </div>
                </i-circle>
              </Col>
              <Col :lg="8" style="text-align: center">
                <i-circle
                  :size="200"
                  :trail-width="4"
                  :stroke-width="5"
                  :percent="(totalHyperVisors.memory.used / totalHyperVisors.memory.total) * 100 > 100 ? 100 : (totalHyperVisors.memory.used / totalHyperVisors.memory.total) * 100"
                  stroke-linecap="square"
                  :stroke-color="(totalHyperVisors.memory.used / totalHyperVisors.memory.total) * 100 > 80 ? dangerColor : cgColor">
                  <div class="demo-Circle-custom">
                    <h3>已用：{{ (totalHyperVisors.memory.used / 1024).toFixed(1) }}GB</h3>
                    <p>总共：{{ (totalHyperVisors.memory.total / 1024).toFixed(1) }}GB</p>
                    <span>
                  <i>内存</i>
                </span>
                  </div>
                </i-circle>
              </Col>
              <Col :lg="8" style="text-align: center">
                <i-circle
                  :size="200"
                  :trail-width="4"
                  :stroke-width="5"
                  :percent="(totalHyperVisors.disk.used / totalHyperVisors.disk.total) * 100 > 100 ? 100 : (totalHyperVisors.disk.used / totalHyperVisors.disk.total) * 100"
                  stroke-linecap="square"
                  :stroke-color="(totalHyperVisors.disk.used / totalHyperVisors.disk.total) * 100 > 80 ? dangerColor : cgColor">
                  <div class="demo-Circle-custom">
                    <h3>已用：{{ totalHyperVisors.disk.used }}GB</h3>
                    <p>总共：{{ totalHyperVisors.disk.total }}GB</p>
                    <span>
                  <i>本地磁盘</i>
                </span>
                  </div>
                </i-circle>
              </Col>
            </Row>
          </Card>
        </Row>
        <Row :gutter="16">
          <Col :lg="12" v-for="item in hyperVisors" :key="`hyper_visor_${item.id}`" style="margin-bottom: 10px">
            <Card shadow>
              <div slot="title">
                <span>主机：<b>{{ item.hypervisor_hostname }} ({{ item.host_ip }}) </b> 实例：<b>{{ item.running_vms }}</b></span>
                <span :style="{color: item.state === 'up' ? 'green' : dangerColor, float: 'right'}">{{ item.state === 'up' ? '启动' : item.state }}</span>
              </div>
              <Row>
                <Col :sm="8" style="text-align: center">
                  <i-circle
                    :size="170"
                    :trail-width="4"
                    :stroke-width="5"
                    :percent="(item.vcpus_used / item.vcpus) * 100 > 100 ? 100 : (item.vcpus_used / item.vcpus) * 100"
                    stroke-linecap="square"
                    :stroke-color="(item.vcpus_used / item.vcpus) * 100 > 80 ? dangerColor : cgColor">
                    <div class="demo-Circle-custom">
                      <h3>已用：{{ item.vcpus_used }}</h3>
                      <p>总共：{{ item.vcpus }}</p>
                      <span>
                        <i>Vcpus</i>
                      </span>
                    </div>
                  </i-circle>
                </Col>
                <Col :sm="8" style="text-align: center">
                  <i-circle
                    :size="170"
                    :trail-width="4"
                    :stroke-width="5"
                    :percent="(item.memory_mb_used / item.memory_mb) * 100 > 100 ? 100 : (item.memory_mb_used / item.memory_mb) * 100"
                    stroke-linecap="square"
                    :stroke-color="(item.memory_mb_used / item.memory_mb) * 100 > 80 ? dangerColor : cgColor">
                    <div class="demo-Circle-custom">
                      <h3>已用：{{ (item.memory_mb_used / 1024).toFixed(1) }}GB</h3>
                      <p>总共：{{ (item.memory_mb / 1024).toFixed(1) }}GB</p>
                      <span>
                        <i>内存</i>
                      </span>
                    </div>
                  </i-circle>
                </Col>
                <Col :sm="8" style="text-align: center">
                  <i-circle
                    :size="170"
                    :trail-width="4"
                    :stroke-width="5"
                    :percent="(item.local_gb_used / item.local_gb) * 100 > 100 ? 100 : (item.local_gb_used / item.local_gb) * 100"
                    stroke-linecap="square"
                    :stroke-color="(item.local_gb_used / item.local_gb) * 100 > 80 ? dangerColor : cgColor">
                    <div class="demo-Circle-custom">
                      <h3>已用：{{ item.local_gb_used }}GB</h3>
                      <p>总共：{{ item.local_gb }}GB</p>
                      <span>
                        <i>本地磁盘</i>
                      </span>
                    </div>
                  </i-circle>
                </Col>
              </Row>
            </Card>
          </Col>
        </Row>
      </div>
    </Row>
    <Alert v-if="projectQuotaError" type="error" show-icon>
      获取租户配额使用情况失败
      <a style="float: right" v-on:click="getProjects">刷新</a>
    </Alert>
    <Row :gutter="16" v-else>
      <Col :lg="12" v-for="(item, index) in projectQuotas" :key="index" style="margin-bottom: 10px">
        <Spin v-if="item.computeQuotaGetting || item.networkQuotaGetting || item.storageQuotaGetting" fix></Spin>
        <Card shadow v-else>
          <div slot="title" v-if="item.project">
            <span>租户配额：<b>{{ item.project.name }}</b></span>
          </div>
          <Alert show-icon v-if="item.computeQuotaError" type="error">计算资源配额数据获取失败</Alert>
          <Alert show-icon v-if="item.networkQuotaError" type="error">网络资源配额数据获取失败</Alert>
          <Alert show-icon v-if="item.storageQuotaError" type="error">存储资源配额数据获取失败</Alert>
          <div v-if="item.quota">
            <Progress v-for="(quotaValue, quotaKey, quotaIndex) in item.quota"
                      class="private-cloud-quota-progress"
                      v-if="!item[`${quotaValue.type}Error`]"
                      :percent="quotaValue.used / quotaValue.total * 100"
                      :key="quotaIndex"
                      :status="(quotaValue.used / quotaValue.total * 100) > 80 ? 'wrong': 'normal'">
              <span>{{ quotaValue.label }} {{ quotaValue.used }}{{ quotaValue.unit }} / {{ quotaValue.total }}{{ quotaValue.unit }}</span>
            </Progress>
          </div>
        </Card>
      </Col>
    </Row>
  </div>
</template>

<script>
import { getPrivateCloudHyperVisorDetailList } from '@/api/private-cloud/hypervisor'
import { getPrivateCloudProject } from '@/api/private-cloud/project'
import { getPrivateCloudComputeQuota } from '@/api/private-cloud/quota-compute'
import { getPrivateCloudNetworkQuota } from '@/api/private-cloud/quota-network'
import { getPrivateCloudStorageQuota } from '@/api/private-cloud/quota-storage'

export default {
  name: 'resource-overview',
  data () {
    return {
      hyperVisorsGetting: false,
      hyperVisorsError: false,
      totalHyperVisors: {
        vcpus: {
          used: 0,
          total: 0
        },
        memory: {
          used: 0,
          total: 0
        },
        disk: {
          used: 0,
          total: 0
        }
      },
      hyperVisors: [],
      pieOption: {
        title: {
          text: '',
          x: 'center'
        },
        tooltip: {
          trigger: 'item',
          formatter: '{a} <br/>{b} : {c} ({d}%)'
        },
        legend: {
          show: false,
          orient: 'vertical',
          left: 'left',
          data: []
        },
        series: [
          {
            name: '',
            type: 'pie',
            radius: '60%',
            center: ['50%', '60%'],
            data: [],
            itemStyle: {
              emphasis: {
                shadowBlur: 10,
                shadowOffsetX: 0,
                shadowColor: 'rgba(0, 0, 0, 0.5)'
              }
            },
            label: {
              normal: {
                formatter: '{b} {c}'
              }
            }
          }
        ]
      },
      cgColor: '#43a3fb',
      dangerColor: 'red',
      projectQuotaGetting: {},
      projectQuotaError: false,
      projectQuotas: []
    }
  },
  created: function () {
    this.getHyperVisors()
    this.getProjects()
  },
  methods: {
    getHyperVisors () {
      this.hyperVisorsGetting = true
      this.hyperVisorsError = false
      getPrivateCloudHyperVisorDetailList().then(res => {
        this.hyperVisors = res.data
        this.totalHyperVisors = {
          vcpus: {
            used: 0,
            total: 0
          },
          memory: {
            used: 0,
            total: 0
          },
          disk: {
            used: 0,
            total: 0
          }
        }
        let NameList = ['已用', '剩余']
        let option = JSON.parse(JSON.stringify(this.pieOption))
        option.legend.data = NameList

        for (let i in this.hyperVisors) {
          const resource = this.hyperVisors[i]
          this.totalHyperVisors.vcpus.used += resource.vcpus_used
          this.totalHyperVisors.vcpus.total += resource.vcpus
          this.totalHyperVisors.memory.used += resource.memory_mb_used
          this.totalHyperVisors.memory.total += resource.memory_mb
          this.totalHyperVisors.disk.used += resource.local_gb_used
          this.totalHyperVisors.disk.total += resource.local_gb
        }
        this.hyperVisorsGetting = false
      }).catch(res => {
        this.hyperVisorsGetting = false
        this.hyperVisorsError = true
        console.error(res.response)
      })
    },
    getProjects () {
      this.projectQuotas = []
      this.projectQuotaError = false
      getPrivateCloudProject().then(res => {
        for (let i in res.data.projects) {
          const project = res.data.projects[i]
          this.projectQuotas.push({
            project: project,
            computeQuotaGetting: true,
            networkQuotaGetting: true,
            storageQuotaGetting: true,
            computeQuotaError: false,
            networkQuotaError: false,
            storageQuotaError: false,
            quota: {
              server: {
                label: '实例',
                type: 'computeQuota',
                used: 0,
                total: 0
              },
              vcpus: {
                label: 'Vcpus',
                type: 'computeQuota',
                used: 0,
                total: 0
              },
              memory: {
                label: '内存',
                type: 'computeQuota',
                unit: 'GB',
                used: 0,
                total: 0
              },
              floating_ip: {
                label: '浮动IP',
                type: 'networkQuota',
                used: 0,
                total: 0
              },
              network: {
                label: '虚拟网络',
                type: 'networkQuota',
                used: 0,
                total: 0
              },
              security_group: {
                label: '安全组',
                type: 'networkQuota',
                used: 0,
                total: 0
              },
              volume: {
                label: '云硬盘',
                type: 'storageQuota',
                used: 0,
                total: 0
              },
              volumeStorage: {
                label: '云硬盘存储',
                type: 'storageQuota',
                unit: 'GB',
                used: 0,
                total: 0
              }
            }
          })
          let index = this.projectQuotas.length - 1

          this.getComputeQuota(project.id, index)
          this.getNetworkQuota(project.id, index)
          this.getStorageQuota(project.id, index)
        }
      }).catch(res => {
        console.error(res.response)
        this.projectQuotaError = true
      })
    },
    getComputeQuota (projectId, index) {
      getPrivateCloudComputeQuota(projectId).then(res => {
        this.projectQuotas[index].computeQuotaGetting = false
        this.projectQuotas[index].computeQuotaError = false
        this.projectQuotas[index].quota.server.used = res.data.quota_set.instances.in_use
        this.projectQuotas[index].quota.server.total = res.data.quota_set.instances.limit
        this.projectQuotas[index].quota.vcpus.used = res.data.quota_set.cores.in_use
        this.projectQuotas[index].quota.vcpus.total = res.data.quota_set.cores.limit
        this.projectQuotas[index].quota.memory.used = (res.data.quota_set.ram.in_use / 1024).toFixed(res.data.quota_set.ram.in_use % 1024 ? 1 : 0)
        this.projectQuotas[index].quota.memory.total = (res.data.quota_set.ram.limit / 1024).toFixed(res.data.quota_set.ram.limit % 1024 ? 1 : 0)
      }).catch(res => {
        this.projectQuotas[index].computeQuotaGetting = false
        this.projectQuotas[index].computeQuotaError = true
        console.log(res.response)
      })
    },
    getNetworkQuota (projectId, index) {
      getPrivateCloudNetworkQuota(projectId).then(res => {
        this.projectQuotas[index].networkQuotaGetting = false
        this.projectQuotas[index].networkQuotaError = false
        this.projectQuotas[index].quota.floating_ip.used = res.data.quota.floatingip.used
        this.projectQuotas[index].quota.floating_ip.total = res.data.quota.floatingip.limit
        this.projectQuotas[index].quota.network.used = res.data.quota.network.used
        this.projectQuotas[index].quota.network.total = res.data.quota.network.limit
        this.projectQuotas[index].quota.security_group.used = res.data.quota.security_group.used
        this.projectQuotas[index].quota.security_group.total = res.data.quota.security_group.limit
      }).catch(res => {
        this.projectQuotas[index].networkQuotaGetting = false
        this.projectQuotas[index].networkQuotaError = true
        console.log(res.response)
      })
    },
    getStorageQuota (projectId, index) {
      getPrivateCloudStorageQuota(projectId).then(res => {
        this.projectQuotas[index].storageQuotaGetting = false
        this.projectQuotas[index].storageQuotaError = false
        this.projectQuotas[index].quota.volume.used = res.data.quota_set.volumes.in_use
        this.projectQuotas[index].quota.volume.total = res.data.quota_set.volumes.limit
        this.projectQuotas[index].quota.volumeStorage.used = res.data.quota_set.gigabytes.in_use
        this.projectQuotas[index].quota.volumeStorage.total = res.data.quota_set.gigabytes.limit
      }).catch(res => {
        this.projectQuotas[index].storageQuotaGetting = false
        this.projectQuotas[index].storageQuotaError = true
        console.log(res.response)
      })
    }
  }
}
</script>

<style>
  .private-cloud-quota-progress.ivu-progress-success .ivu-progress-bg,
  .private-cloud-quota-progress.ivu-progress-success .ivu-progress-success-bg {
    background-color: #ed4014
  }
  .private-cloud-quota-progress.ivu-progress-success .ivu-progress-text {
    color: #ed4014
  }
</style>
